import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './PhotographyContact.css';

const PhotographyContact = () => {


  return (
    <section className="photography-contact-section">
      {/* Background Elements */}
      <div className="contact-gradient-overlay" />
      <div className="contact-particles">
        {[...Array(15)].map((_, i) => (
          <div 
            key={i}
            className="contact-particle"
            style={{
              '--delay': `${i * 0.3}s`,
              '--size': `${Math.random() * 6 + 2}px`,
              '--x': `${Math.random() * 100}%`,
              '--y': `${Math.random() * 100}%`
            }}
          />
        ))}
      </div>
      
      <div className="contact-container">
        {/* Feature Badges */}
      

        {/* ── Heading ── */}
        <motion.h2
          className="contact-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Let us photograph your next event
        </motion.h2>

        {/* ── Description ── */}
        <motion.p
          className="contact-description"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          Capturing unforgettable moments has never been more essential,
          <br />
          and partnering with a pro team has never been easier.
        </motion.p>

        {/* ── CTA Section ── */}
        <motion.div
          className="contact-cta-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <Link to="/contact" className="contact-link">
            <motion.button
              className="contact-btn"
              whileHover={{ 
                scale: 1.05,
                transition: { type: "spring", stiffness: 400, damping: 10 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="btn-text">Contact&nbsp;Us</span>
              <span className="btn-arrow">→</span>
              <div className="btn-shine"></div>
              <div className="btn-hover-fill"></div>
            </motion.button>
          </Link>

          {/* Trust Badges */}
       
        </motion.div>
      </div>
    </section>
  );
};

export default PhotographyContact;
